/* eslint-disable */

// <----- API URL  -------> 
export const APIUrl = {
    login: '/lg/authorisation/login',
};

// <----- Environment types  -------> 
export const ENV_TYPE = {
    DEV: 'dev',
    PROD: 'prod',
    UAT: 'uat'
};

// <----- Environments  -------> 
export const ENV = {
    ['dev']: 'https://briisk-i-dev-api.azure-api.net',
    ['uat']: 'https://briisk-i-uat-api.azure-api.net',
    ['prod']: 'https://api-itp2-prod-za.azure-api.net'
};


export const OCP_APIM_SUBSCRIPTION_KEY = {
    ['dev']: 'ec2659d3859d421d801776e4efad5780',
    ['uat']: '3296a582dbb540b8ae4843332c638a3e',
    ['prod']: '8540156a8296482cb7707d758b0c9fb4'
}
  
export const PRODUCT_INSTANCE_ID = {
    ['dev']: '1DE7B3E2-3670-ECF6-6DE0-8EF56DB170A4',
    ['uat']: 'E3AFC99C-5F47-4060-A9AF-BB5587DBADE6',
    ['prod']: '3816ead7-6fb9-41af-ae8c-09167b5319d5'
}


export const AUTH_EMAIL = {
    ['dev']: 'briisk@itoo.co.za',
    ['uat']: 'cybersme@itoo.co.za',
    ['prod']: 'surething@briisk.io'
}

export const AUTH_PASSWORD = {
    ['dev']: 'Br!!5k3105',
    ['uat']: 'Cyb3r5M32021',
    ['prod']: '!hcSHuL3rWiW6r.'
}

export const IVERY_BASEURL = {
    ['dev']:  'https://portal.nedsecure.co.za/Lite/Authorise.aspx',//'https://portal.iveri.net/Lite/Authorise.aspx',
    ['uat']:  'https://portal.nedsecure.co.za/Lite/Authorise.aspx',
    ['prod']: 'https://portal.nedsecure.co.za/Lite/Authorise.aspx'
}
  
export const LITE_MERCHANT_APP_ID = {
    ['dev']:  'FFE710FD-A540-4304-B296-0814EB8D7D25', //'753B138D-3720-4744-B075-89DF833433BC',
    ['uat']:  'FFE710FD-A540-4304-B296-0814EB8D7D25', //'753B138D-3720-4744-B075-89DF833433BC',
    ['prod']: '7a0fa866-d79d-4ce9-8ba7-232ae494463c'
}

export const BANK_BRANCH_GUID = {
    ['dev']: 'F5D22457-30FC-8FC4-90DB-BC43DC258464',
    ['uat']: '201413A3-4410-B6C1-498E-7FD5D7100874',
    ['prod']: '7b9d8f0d-62fe-cf02-d6cf-0e5dafccef01'
}


export const NETWORK_ID = {
    ['dev']: '96d8b9ec-ae4e-4108-9a3b-52260d695e6b',
    ['uat']: 'f696fd88-3c18-debf-5b04-b3447caa076d',
    ['prod']: '6d94b2b3-aa0f-f43b-f817-fd67f90b521f'
}

  
export const COMPANY_ID = {
    ['dev']: 'bf685a12-658c-eed5-4318-5965fecd1e71',
    ['uat']: '3B6B26B7-C881-2FBF-A0AA-2BDF3A1C045B',
    ['prod']: '2E219BBC-52ED-42FE-9A37-02849FD37E24'
}

export const PAYMENT_CONFIGURATION_KEY = {
    ['dev']: 'bd46596c-6562-4f7a-96d4-1e8c058da19a',
    ['uat']: '1e8e383c-df6c-469f-ab85-91f48bcecd4f',
    ['prod']: '2ab00e39-bce2-4443-b8af-407c5346d17d' 
}

export const COMPANY_CODE = {
    ['dev']: 'i2',
    ['uat']: 'i2',
    ['prod']: '47320'
}

export const MIDDLEWARE_URL = {
    // ['dev']: 'http://localhost:5000',
    ['dev']: 'https://react-middleware-dev.azurewebsites.net',
    ['uat']: 'https://react-middleware-uat.azurewebsites.net',
    ['prod']: 'https://react-middleware-prod.azurewebsites.net',
    // ['prod']: 'http://localhost:8000', 
}

export const RECAPTCHA_SITE_KEY = {
    ['dev']: '6LdqUl8eAAAAAEqMOm497Kzz5RjOAObKpHfs0eyR',
    ['uat']: '6LeiwyIeAAAAANOg__eUKzJoQazt7w_AIVybPhKF',
    ['prod']: '6LcOrr0eAAAAAHq2fykrVpO9_jWccw02_PcT0fLy' // Surething LIVE
}


/* eslint-disable */

export const SITE_URL = {
  ["dev"]: "https://react-surething-dev.azurewebsites.net",
  ["uat"]: "https://react-surething-uat.azurewebsites.net",
  ["prod"]: "https://surething.thinkexpert.co.za",
};